import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../settings/index';
import Api from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';

const api = new Api('dashboard/pools');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;
    const search = { page, pageSize, column, order, filter, ...payload };

    const result = yield call(sendRequest, api.load, { search }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters, saved_searches } = result.data.success.data;

      records.map(record => record.actions.push({ key: 'show_pool_funnel' }));

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters,
          savedSearches: saved_searches,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
